import { FC } from 'react';
import { useQuery } from '@apollo/client';
import * as K from 'common/constants';
import ELEMENT from 'common/element';
import Page from 'components/common/Page/Page';
import PageHeader from 'components/common/PageHeader/PageHeader';
import LoadingPlaceholder from 'components/common/LoadingPlaceholder/LoadingPlaceholder';
import ChangePasswordForm from 'components/changePassword/ChangePasswordForm';
import { GET_ACCOUNT_QUERY } from './queries';

import './ChangePassword.scss';

const ChangePasswordPage: FC = () => {
  const { data, loading } = useQuery<{ account: { isSSOAuthenticated: boolean } }>(GET_ACCOUNT_QUERY);

  if (loading) {
    return <LoadingPlaceholder />;
  }

  return (
    <Page docTitle="Change Password" testId={ELEMENT.changePasswordPage}>
      <PageHeader title="Change Password" />
      {data?.account.isSSOAuthenticated ? (
        <p>
          Your account is authenticated using your company&apos;s identity provider. If you would like to change your
          password, change it in your identity provider. If you need to change your Scalyr password and you are not
          logging in through your company&apos;s identity provider, please report the issue to Support.
        </p>
      ) : (
        <>
          <p>Use this page to update the password for your {K.PRODUCT_NAME} account.</p>
          <ChangePasswordForm />
        </>
      )}
    </Page>
  );
};

export default ChangePasswordPage;
